import { Input, Component, OnInit } from "@angular/core";
import { NavController, Platform } from "ionic-angular";

import { Token, TokenStatus } from "../../app/app.models";
import { TokenPage } from "../../pages/token/token";
import { ConfigService } from "../../services/config.service";

import { WatacardLoadingSerivce } from "../../services/watacard.loading.service";

@Component({
  selector: "token",
  templateUrl: "token.html",
})
export class TokenComponent implements OnInit {
  @Input()
  public private: boolean = true;
  @Input()
  public value: Token;
  temp: boolean = false;
  watacoins: string;
  ios: boolean;

  public TokenStatus = {
    Released: TokenStatus.Released,
    ForSale: TokenStatus.ForSale,
    Unfungible: TokenStatus.Unfungible,
  };

  constructor(
    public navCtrl: NavController,
    public loadingService: WatacardLoadingSerivce,
    private configService: ConfigService,
    public platform: Platform
  ) {
    if (this.platform.is("ios")) {
      this.ios = true;
    } else {
      this.ios = false;
    }
    this.ios = false;
  }

  openTokenPage() {
    if (!this.private) this.navCtrl.push(TokenPage, this.value);
  }

  ngOnInit() {
    this.watacoins = this.formatNumberDeciaml(this.value.next_price, 0);
    var asset: Token;

    this.loadingService.getTempAsset().then((temp_asset) => {
      asset = temp_asset;
      if (asset) {
        if (this.value.assetId === asset.assetId) {
          this.loadingService
            .validateTransaction(this.value)
            .then((loading: any) => {
              this.temp = loading;
            })
            .catch((loading) => {
              this.temp = loading;
              if (!this.temp) {
                this.loadingService.deleteTempAsset();
              }
            });
        }
      } else {
        this.temp = false;
      }
    });
  }

  formatNumberDeciaml(value: number, decimal: number): string {
    var formatValue;
    var idiom = this.configService.getIdiom();
    if (idiom == "es")
      formatValue = new Intl.NumberFormat("es-ES", {
        maximumFractionDigits: decimal,
      }).format(value);

    if (idiom == "en")
      formatValue = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: decimal,
      }).format(value);

    return formatValue;
  }
}



// WEBPACK FOOTER //
// ./src/components/token/token.ts